import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* About IBX Section */}
          <div>
            <h3 className="text-xl font-bold text-white mb-6">ABOUT IBX</h3>
            <p className="text-gray-300 mb-6 leading-relaxed">
              IBX Global Shipping & Logistics Limited is a premier provider of logistics and procurement solutions, 
              our mission is to connect international markets with precision and reliability.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-facebook-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-twitter-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-reddit-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Photo Gallery Section */}
          <div>
            <h3 className="text-xl font-bold text-white mb-6">PHOTO GALLERY</h3>
            <div className="grid grid-cols-3 gap-3">
              <img 
                src="https://readdy.ai/api/search-image?query=Modern%20warehouse%20with%20forklift%20loading%20cargo%20containers%2C%20professional%20logistics%20facility%20with%20organized%20storage%20and%20shipping%20operations%2C%20industrial%20setting%20with%20blue%20and%20orange%20lighting&width=120&height=120&seq=gallery-1&orientation=squarish"
                alt="Warehouse Operations"
                className="w-full h-20 object-cover rounded"
              />
              <img 
                src="https://readdy.ai/api/search-image?query=Cargo%20ship%20containers%20stacked%20at%20modern%20port%20terminal%2C%20blue%20shipping%20containers%20with%20cranes%20in%20background%2C%20professional%20maritime%20logistics%20scene&width=120&height=120&seq=gallery-2&orientation=squarish"
                alt="Port Operations"
                className="w-full h-20 object-cover rounded"
              />
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20logistics%20team%20workers%20in%20safety%20vests%20coordinating%20shipping%20operations%2C%20diverse%20team%20managing%20cargo%20and%20containers%20in%20modern%20facility&width=120&height=120&seq=gallery-3&orientation=squarish"
                alt="Team Operations"
                className="w-full h-20 object-cover rounded"
              />
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 IBX Shipping. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
